import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Field, ErrorBox, Loading } from "@/components/common";
import { AuthFrame } from "@/pages/Login";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useI18n, ROLES } from "@/lib/i18n";

export default function AcceptInvite() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const { tx, lbl } = useI18n();
  const { setUser } = useAuth();
  const nav = useNavigate();
  const [inv, setInv] = useState(null);
  const [err, setErr] = useState("");
  const [name, setName] = useState("");
  const [pw, setPw] = useState("");
  const [accept, setAccept] = useState(false);

  useEffect(() => {
    api.get(`/auth/invitations/${token}`).then((r) => { setInv(r.data); setName(r.data.name || ""); }).catch((e) => setErr(errMsg(e)));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await api.post("/auth/invitations/accept", { token, name, password: pw, accept_confidentiality: accept });
      setUser(data.user);
      nav("/account");
    } catch (e2) { setErr(errMsg(e2)); }
  };

  return (
    <AuthFrame title={tx("Activer votre compte", "Activate your account")} subtitle={inv ? `${inv.email} · ${lbl(ROLES, inv.platform_role)}${inv.audit_title ? ` · ${inv.audit_title}` : ""}` : ""}>
      {!inv && !err && <Loading />}
      {err && <ErrorBox error={err} />}
      {inv && (
        <form onSubmit={submit} className="space-y-4" data-testid="accept-invite-form">
          <Field label={tx("Nom complet", "Full name")}><Input data-testid="invite-name-input" value={name} onChange={(e) => setName(e.target.value)} required /></Field>
          <Field label={tx("Mot de passe", "Password")} hint={tx("10 caractères minimum, lettres et chiffres.", "Minimum 10 characters, letters and digits.")}>
            <Input data-testid="invite-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required />
          </Field>
          <label className="flex gap-3 items-start text-sm text-slate-700">
            <Checkbox data-testid="invite-confidentiality-checkbox" checked={accept} onCheckedChange={(v) => setAccept(!!v)} className="mt-0.5" />
            {tx("Je m'engage à respecter la confidentialité des données clients et salariés, et à n'utiliser l'outil que pour les missions qui me sont attribuées.",
              "I commit to keep client and employee data confidential and to use the tool only for missions assigned to me.")}
          </label>
          <Button type="submit" data-testid="invite-submit" disabled={!accept} className="w-full bg-[#153A63]">{tx("Activer", "Activate")}</Button>
          <p className="text-xs text-slate-500">{tx("Après activation, configurez l'authentification à deux facteurs (MFA).", "After activation, set up two-factor authentication (MFA).")}</p>
        </form>
      )}
    </AuthFrame>
  );
}
